<template>
    <div class="mt-2">
      <div class="d-flex mb-2 align-items-center" style="padding: 0 15px;">
        <div class="input-group-icon input-group-icon-left" style="flex: 0 0 auto; width: 275px;">
          <span class="input-icon input-icon-right font-20">
            <i class="fa fa-search"></i>
          </span>
          <input class="form-control rounded-pill search" v-model="searchKeyword" type="text"
                 placeholder="検索...">
        </div>
        <button v-if="!disableColumns.includes('create')" class="btn create-template-btn" @click="createNewTemplate" style="margin-left: 30px;">
          新規作成する
        </button>
      </div>

      <div class="table-responsive">
        <table class="custom-table table-bordered dataTable table-hover" id="datatable">
          <thead class="thead-default thead-lg">
            <tr>
              <th scope="col" style="width:8%; text-align: center; white-space: nowrap;" v-if="!disableColumns.includes(0)">
                <span class="sortable">並び替え</span>
              </th>
              <th scope="col" style="width:8%; text-align: center; white-space: nowrap;">
                <span class="sortable">表示順</span>
              </th>
              <th scope="col" style="width:25%;">
                <span class="sortable">テンプレート名</span>
              </th>
              <th scope="col" style="width:20%;">
                <span class="sortable">件名</span>
              </th>
              <th scope="col" style="width:15%;">
                <span class="sortable">スカウト形式</span>
              </th>
              <th scope="col" style="text-align: center; width: 12%" v-if="!disableColumns.includes(4)">操作</th>
            </tr>
          </thead>
          <tr v-if="(typeof filteredTemplates === typeof [] && filteredTemplates.length === 0) || allTemplates.length === 0">
              <td colspan="6" style="text-align: center;">No records found</td>
          </tr>
          <draggable 
            :list="draggableList" 
            tag="tbody" 
            :disabled="dragOptions" 
            @end="onDragEnd"
            handle=".drag-handle"
            v-else
          >
            <tr v-for="(template,index) in filteredTemplates || allTemplates" :key="template._id" @click.stop="rowSelected(template._id)">
              <td style="text-align: center;" class="drag-handle" v-if="!disableColumns.includes(0)">
                <img 
                  :src="require('@/assets/images/drag-handle.svg')" 
                  alt="並び替え"
                  style="width: 20px; height: 20px;"
                />
              </td>
              <td style="text-align: center;">{{ template.idx || index + 1 }}</td>
              <td style="text-align: left;">{{ template.name }}</td>
              <td style="text-align: left;">{{ template.subject || '-' }}</td>
              <td>
                <span class="contact-type" v-if="template.contact_type">
                  {{ template.contact_type}}
                </span>
                <span v-else>-</span>
              </td>
              <td v-if="!disableColumns.includes(4)">
                <slot name="actions" v-bind:template="template">

                </slot>
              </td>
            </tr>
          </draggable>
        </table>
      </div>

      <slot name="messageTemplate">
          
      </slot>
    </div>
  </template>
  
  <script>
  import draggable from 'vuedraggable';
  import { mapMutations, mapActions, mapGetters } from 'vuex';
  import ApiService from '@/service/apiService';
  import Api from '@/config/api';
  
  export default {
    name: "ListMailTemplate",
    components: {draggable},
    props: {
      "types": {
        type: [],
        required: false
      },
      "isDragDisabled":{
        type:Boolean,
        // default:true
      },
      "disableColumns": {
        type: [],
        default: () => [],
        required: false
      },
      "isReplyTemplate": {
        type: Boolean,
        default: false
      }
      // "allTemplates": {
      //   type: [],
      //   required: true
      // },}
    },
    data() {
      return {
        originalTemplates: [],
        replyTemplates: [],
        sendTemplates: [],
        errors:[],
        filteredTemplates: undefined,
        selectedType: "All",
        searchKeyword: "",
        sort_col: 1,
        isSubmitting: false
      }
    },
    computed:{
      ...mapGetters({allTemplates: "getAllMessageTemplates"}),
      dragOptions(){
        return Boolean(this.searchKeyword.trim()) || this.isDragDisabled || this.isSubmitting || this.disableColumns.includes(0);
      },
      draggableList(){
        return this.filteredTemplates && this.filteredTemplates.length>0 ? this.filteredTemplates : this.allTemplates;
      },
    },
    methods: {
      ...mapMutations({
        setAllTemplates: 'SET_ALL_MESSAGE_TEMPLATES'
      }),
      ...mapActions([
         "loadAllMessageTemplates","removeFlashMessage", "addFlashMessages", "removeAllFlashMessages"
      ]),
      // templateClickAction(){
      //   if(!disableColumns.includes(4)) {
          
      //   }
      // },
      search(keyword) {
        let filtered_array = this.allTemplates.filter(template => {
          return template.subject.toLowerCase().includes(keyword.toLowerCase()) ||
              template.idx.toString().toLowerCase().includes(keyword.toLowerCase()) || 
              template.name.toLowerCase().includes(keyword.toLowerCase());
        });
        this.filteredTemplates = [...filtered_array];
      },
      onDragEnd() {
        // Update positions after drag
        let newTemplates = [...this.allTemplates];
        newTemplates.forEach((item, index) => {
          item.position = index + 1;
          item.idx = index + 1;
        });
        // Call API to save new order
        this.reOrder();
      },
      checkOrder(){
        let newTemplates = [...this.allTemplates];
        newTemplates.forEach((item,index)=>{item.position = index+1; item.idx=index+1});
      },
      async reOrder(){
        this.isSubmitting = true;
        try{
          let reorderedTemplates = this.allTemplates.map((template)=>{
            const { idx, ...rest } = template;
            return rest;
          })
  
          let res =  await ApiService.put(Api.endpoints.REORDER_MESSAGE_TEMPLATE, {reorderedTemplates:reorderedTemplates});
          
          this.setAllTemplates(res.data.data.map((data, idx) => {
            data['idx'] = idx + 1;
            return data;
          }));
  
          this.addFlashMessages([{message: 'テンプレートの再読み込みを実行しました', type: "success"}]);
          setTimeout(() => {
            this.removeAllFlashMessages();
          }, 5000);
          this.isSubmitting=false;
        }catch(err){
          this.setAllTemplates(this.originalTemplates);
          this.errors = [];
          this.parseErrorResponse(err.response);
          this.addFlashMessages([{message: this.errors[0], type: "danger"}]);
          setTimeout(() => {
            this.removeAllFlashMessages();
          }, 5000);
          this.isSubmitting=false;
          console.log(err);
        }
      },  
      rowSelected(id) {
        if(this.disableColumns.includes(4)) {
          this.$emit("rowSelected", id); 
        }
      },
      createNewTemplate() {
        this.$emit("createTemplate");
      }
    },
    watch: {
      selectedType(newSate) {
        this.$emit('typeChanged', newSate);
      },
      searchKeyword(newData) {
        if (newData.trim() !== "") {
          this.search(newData);
        }
        else {
          this.filteredTemplates = undefined;
        }
      }
    },
    async mounted() {
      await this.loadAllMessageTemplates();
      this.originalTemplates = [...this.allTemplates.filter(template => !template.is_reply_template)];
      // this.replyTemplates = this.allTemplates.filter(template => template.is_reply_template);
    },
  }
  </script>
  
  <style scoped>
  .contact-type {
    display: block;
    width: 116px;
    margin: auto;
    padding: 6px;
    border-color: #787878;
    background-color: #787878;
    border-radius: 4px;
    color: #ffffff;
  }
  .input-group-icon {
    position: relative;
    color: #71808f;
  }
  
  .btn-container{
    padding: 5px;
  }
  
  .input-group-icon .input-icon {
    position: absolute;
    top: -1px;
    height: 100%;
    width: 40px;
    display: flex;
    justify-content: center;
    align-items: center;
  }
  
  .font-20 {
    font-size: 20px !important;
  }
  
  .font-16 {
    font-size: 16px !important;
  }
  
  .search {
    padding-left: 40px;
    background: #f4f5f9;
    border-color: #f4f5f9;
    font-size: .9rem;
  }
  
  .search:focus {
    box-shadow: none;
    border-color: #036D6C;
    background-color: #e4e6f0;
  }
  
  table.dataTable {
    width: 100% !important;
    border-collapse: collapse !important;
    clear: both;
    margin-top: 6px !important;
    margin-bottom: 6px !important;
    max-width: none !important;
  }
  
  .table-bordered {
    border: 1px solid #ededee;
  }
  
  .sortable {
    display: inline-flex;
    justify-content: center;
    align-items: center;
    width: 100%;
  }
  
  .sortable i {
    color: #c2c8ce;
    margin-left: 1rem;
  }

  .custom-table td {
    padding: 0.75rem; 
  }

  .custom-table th {
    padding: 0.75rem; 
  }
  
  td {
    font-weight: 500;
    vertical-align: middle !important;
    word-break: break-all;
    text-align: center;
    border: none !important;
    border-bottom: 1px solid #787878 !important;
    /* color: #036AC9 */
  }
  
  th {
    vertical-align: middle !important;
    border-top: none !important;
    border: none !important;
    border-bottom: 1px solid #787878 !important;
  }
  
  .actions {
    min-width: 100px;
  }
  
  .actions .btn-sm {
    border-radius: 0;
    padding: 0 8px;
    min-width: 0;
  }
  
  .actions .btn-sm .icon {
    height: 20px;
    width: 20px;
  }
  
  .active {
    color: #212529 !important
  }

  .create-template-btn {
    background-color: #006c6b;
    color: #fff;
    border: none;
    padding: 10px 20px;
    border-radius: 25px;
    font-size: 16px;
    white-space: nowrap;
    min-width: 130px;
    height: 45px;
  }

  .create-template-btn:hover {
    background-color: #005554;
    color: #fff;
  }

  .create-template-btn:focus {
    box-shadow: none;
    outline: none;
  }

  .drag-handle {
    cursor: grab;
    user-select: none;
  }

  .drag-handle:active {
    cursor: grabbing;
  }

  .drag-handle:hover {
    opacity: 0.7;
  }

  tbody tr {
    transition: background-color 0.2s ease;
  }

  tbody tr:hover {
    background-color: #f8f9fa;
  }
  </style>